import type { App } from 'vue'
import { entries, merge, set } from 'lodash-es'
import { createI18n } from 'vue-i18n'
import { loadStorage } from '@/utils/cache'
import { DEFAULT_LOCALE_KEY, LOCALE_KEY } from '@/constant/cache-key'
import type { LocalType } from '@/types/interfaces'
import store from '@/store'
import type { LocalesMap } from '@/store/modules/locale/types'

// 全局语言包
const commonZh: Record<string, any> = import.meta.glob('../locales/*.zh-cn.json', { eager: true, import: 'default' })
const commonEn: Record<string, any> = import.meta.glob('../locales/*.en-us.json', { eager: true, import: 'default' })

// 页面语言包
const pageZh: Record<string, any> = import.meta.glob('../views/**/locales/*.zh-cn.json', { eager: true, import: 'default' })
const pageEn: Record<string, any> = import.meta.glob('../views/**/locales/*.en-us.json', { eager: true, import: 'default' })

function assignLang(lang: Record<string, any>, origin: Record<string, any>) {
  entries(lang).forEach(([filePath, value]) => {
    // 提取命名空间
    // const match = filePath.match(/\/locales\/(.*?)(?:\.zh-cn|\.en-us)\.json$/)
    // const match = filePath.match(/\/locales\/(.*?)(?:\.(\w{2}-\w{2}))?\.json$/)
    // const namespace = match ? match[1].replace(/\//g, '.') : ''
    const namespace = filePath.replace(/.*\/locales\/(.*?)(?:\.\w+-\w+)?\.json$/, '$1')

    if (namespace) {
      const _langs: Record<string, any> = {}
      set(_langs, namespace, value)
      merge(origin, _langs)
    }
    else {
      merge(origin, value)
    }
  })
}

function getLang() {
  const zh: Record<string, any> = {}
  const en: Record<string, any> = {}

  assignLang(commonZh, zh)
  assignLang(pageZh, zh)
  assignLang(commonEn, en)
  assignLang(pageEn, en)

  return { zh, en }
}

const { zh, en } = getLang()
const locale = loadStorage<LocalType>(LOCALE_KEY, DEFAULT_LOCALE_KEY)
const messages: LocalesMap = { 'en-US': en, 'zh-CN': zh }

const i18n = createI18n({
  locale,
  globalInjection: true,
  fallbackLocale: DEFAULT_LOCALE_KEY,
  legacy: false,
  allowComposition: true,
  messages,
})

export default {
  install: (app: App<Element>) => {
    const { setLocals } = store.localeStore
    setLocals(messages)
    app.use(i18n)
  },
}

export { i18n, getLang }
